import { getAuth0AccessToken } from '../../auth/auth0Client';
import { getGoogleToken } from '../../auth/google';
import { API_BASE_URL } from '../config';
import { AppError, parseErrorResponse } from '../errors';

export async function googleFetch<T>(
  endpoint: string,
  options: { method?: string; body?: unknown } = {}
): Promise<T> {
  const auth0Token = await getAuth0AccessToken();
  const googleToken = getGoogleToken();

  if (!auth0Token) {
    throw new Error('Auth0 authentication required');
  }
  if (!googleToken) {
    throw new Error('Google authentication required');
  }

  const headers: HeadersInit = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${auth0Token}`,
    'X-Google-Access-Token': googleToken,
  };

  const response = await fetch(`${API_BASE_URL}${endpoint}`, {
    method: options.method ?? 'POST',
    headers,
    body: JSON.stringify(options.body ?? {}),
  });

  if (!response.ok) {
    const errorPayload = await parseErrorResponse(response);
    if (errorPayload) {
      throw new AppError(errorPayload, response.status);
    }
    throw new Error(`Google request failed with status ${response.status}`);
  }

  return response.json() as Promise<T>;
}
